import configEnv from '@/enums/configEnv';
import LogService from '@/services/LogService';
import wpSection from "@/enums/wpSection";
import getLang from "@/mixins/getLang";
import logService from "@/services/LogService";
import {mapState} from "vuex";


const setLayout = {
  mixins: [getLang],
  methods: {
    async getDesign() {
      LogService.log('getDesign');
      const lang = this.getLang();
      await Promise.all([
        this.getPageStrings([wpSection.PARTNER_DESIGN, wpSection.FRONT_PAGE_MENU], undefined, lang),
      ]);
      if (this.partnerCode) {
        await this.waitForPartnerDesign();
        const partnerInfos = this.getPartnerDesign(this.partnerCode, this.strings.partnerDesign);
        if (partnerInfos) {
          this.setCssVariables({
            primary: partnerInfos.primary,
            secondary: partnerInfos.secondary,
            button_background_color: partnerInfos.primary
          });
          return;
        }
      }
      this.setCssVariables();
    },
    getPartnerDesign(partnerCode, partnerInfo) {
      LogService.log('partner', partnerCode);
      if (!partnerInfo || !partnerInfo?.design) {
        return undefined;
      }
      for (let i = 0; i < partnerInfo.design.length; i += 1) {
        const entry = partnerInfo.design[i];
        for (let j = 0; j < entry.partners.length; j += 1) {
          const partner = entry.partners[j];
          if (partner.codes.includes(partnerCode)) {
            return entry;
          }
        }
      }
      return undefined;
    },
    waitForPartnerDesign(timeout = 5000) {
      return new Promise((resolve) => {
        const startTime = Date.now();
        const check = () => {
          if (this.strings && this.strings.partnerDesign) {
            resolve(true);
          } else if (Date.now() - startTime > timeout) {
            LogService.log('Timeout waiting for this.strings.partnerDesign');
            resolve(false); // Verhindert endloses Blockieren bei Fehler
          } else {
            setTimeout(check, 50);
          }
        };
        check();
      });
    },
    setCssVariables({
      primary = configEnv.primary_color,
      secondary = configEnv.secondary_color,
      tertiary = configEnv.tertiary_color,
      quaternary = configEnv.quaternary_color,
      quinary = configEnv.quinary_color,
      senary = configEnv.senary_color,
      septenary = configEnv.septenary_color,
      padding_horizontal_input_fields = configEnv.padding_horizontal_input_fields,
      border_radius = configEnv.border_radius,
      border_input_color = configEnv.border_input_color,
      button_text_color = configEnv.button_text_color,
      button_background_color = configEnv.button_background_color,
    } = {}) {
      const root = document.documentElement;
      if (root) {
        root.style.setProperty('--primary-rgb', this.colorHexToRgb(primary));
        root.style.setProperty('--secondary-rgb', this.colorHexToRgb(secondary));
        root.style.setProperty('--primary', primary);
        root.style.setProperty('--secondary', secondary);
        root.style.setProperty('--tertiary', tertiary);
        root.style.setProperty('--quaternary', quaternary);
        root.style.setProperty('--quinary', quinary);
        root.style.setProperty('--senary', senary);
        root.style.setProperty('--septenary', septenary);
        root.style.setProperty('--padding-horizontal-input-fields', padding_horizontal_input_fields);
        root.style.setProperty('--border-radius', border_radius);
        root.style.setProperty('--border-input-color', border_input_color);
        root.style.setProperty('--button_text_color', button_text_color);
        root.style.setProperty('--button-background-color', button_background_color);
        root.style.setProperty('--button-background-color-rgb', this.colorHexToRgb(button_background_color));
      }
    },
    colorHexToRgb(color) {
      const hexColor = color.replace('#', '');
      const [r, g, b] = [0, 2, 4].map((i) => hexColor.slice(i, i + 2));
      const grbInt = [r, g, b].map((c) => parseInt(c, 16));
      return grbInt.join(', ');
    },
    getVacationBackgroundImage(partnerDesign, vacationStrings) {
      if (partnerDesign && partnerDesign.background?.sizes) {
        return partnerDesign.background.sizes;
      }
      return vacationStrings.background_image.sizes;
    },
    getVacationPartnerLogo(partnerDesign) {
      if (partnerDesign && partnerDesign.logo?.sizes?.medium) {
        return partnerDesign.logo.sizes.medium;
      }
      return '';
    },
    getShowLogoAlwaysOnTop(partnerDesign) {
      if (partnerDesign) {
        return partnerDesign.show_logo_always_on_top;
      }
      return true;
    },
    updateVacationString(vacationStrings, partnerDesign) {
      if (!partnerDesign || !vacationStrings) return vacationStrings;

      logService.log('updateVacationString', partnerDesign, vacationStrings);

      return {
        ...vacationStrings,
        ...(partnerDesign.start_date && {start_date_label: partnerDesign.start_date}),
        ...(partnerDesign.end_date && {end_date_label: partnerDesign.end_date})
      };
    }
  },
  computed: {
    ...mapState(['strings']),
  }
};

export default setLayout;
